import z from 'zod';
export const CLIENT_VARIABLE_MAPPING = {
    emailAddress: 'ENTREPRISE_1_EMAIL_CONTACT',
    legalForm: 'ENTREPRISE_1_FORME_JURIDIQUE',
    legalName: 'ENTREPRISE_1_DENOMINATION_SOCIALE',
    'legalRepresentative.firstName': 'REPRESENTANT_LEGAL_1_PRENOM',
    'legalRepresentative.jobTitle': 'REPRESENTANT_LEGAL_1_FONCTION',
    'legalRepresentative.lastName': 'REPRESENTANT_LEGAL_1_NOM',
    'mainSignatory.firstName': 'SIGNATAIRE_1_PRENOM',
    'mainSignatory.jobTitle': 'SIGNATAIRE_1_FONCTION',
    'mainSignatory.lastName': 'SIGNATAIRE_1_NOM',
    rcsRegistrationCity: 'ENTREPRISE_1_VILLE_IMMATRICULATION_RCS',
    'registeredOfficeAddress.address': 'ENTREPRISE_1_ADRESSE_SIEGE_SOCIAL',
    'registeredOfficeAddress.city': 'ENTREPRISE_1_VILLE_SIEGE_SOCIAL',
    'registeredOfficeAddress.postalCode': 'ENTREPRISE_1_CODE_POSTAL_SIEGE_SOCIAL',
    shareCapital: 'ENTREPRISE_1_CAPITAL_SOCIAL',
    sirenNumber: 'ENTREPRISE_1_SIREN',
    'urssafAddress.address': 'ENTREPRISE_1_ADRESSE_URSSAF',
    'urssafAddress.city': 'ENTREPRISE_1_VILLE_URSSAF',
    'urssafAddress.postalCode': 'ENTREPRISE_1_CODE_POSTAL_URSSAF',
};
const clientDocxVariableValues = Object.values(CLIENT_VARIABLE_MAPPING);
if (clientDocxVariableValues.some((value, index) => clientDocxVariableValues.indexOf(value) !== index)) {
    throw new Error('CLIENT_VARIABLE_MAPPING: duplicate DOCX variable values');
}
export const clientDocxVariableValue = z.enum(clientDocxVariableValues);
export const clientDocxVariable = (value) => clientDocxVariableValue.parse(value);
export const isClientDocxVariable = (value) => clientDocxVariableValue.safeParse(value).success;
//# sourceMappingURL=client-variable-mapping.js.map